<template>
<!-- @click="dispatch(false)" -->
  <div
    class="epr_wrap-style _boxBg_dark_secondLevel absolute_center"
  >
    <div class="module-title">环保道路详情</div>
    <div class="selfClose_btn" @click="close"></div>
    <div class="epr-content-wrap">
      <div class="epr-info">
        <div class="info-line">
          <div class="info-item">
            <span class="label">道路名：</span>
            <span class="value">{{ roadName }}</span>
          </div>
          <div class="info-item">
            <span class="label">道路等级：</span>
            <span class="value">{{ roadTypeName }}</span>
          </div>
          <div class="info-item">
            <span class="label">道路清洁度指数：</span>
            <template
              v-if="datailData.riskLevel && Number(datailData.riskLevel) <= 3"
            >
              <span v-for="(item, index) in Number(datailData.riskLevel)
                ? Number(datailData.riskLevel): 0" :key="index" class="star"></span>
            </template>
            <template v-if="datailData.riskLevel && Number(datailData.riskLevel) > 3">
              <span class="value">--</span>
            </template>
          </div>
        </div>
        <div class="info-line">
          <div class="info-item">
            <span class="label">闭环控制状态：</span>
            <span class="value">{{
              datailData.handleState == 0
                ? "已创建"
                :datailData.handleState == 1
                ? "进行中"
                : datailData.handleState == 2
                ? "已完成"
                : datailData.handleState == 3
                ? "已撤销"
                : "未创建"
            }}</span>
          </div>
          <div class="info-item">
            <span class="label">今日调度次数：</span>
            <span class="value">{{ datailData.scheduleCount }}</span>
          </div>
          <div class="info-item">
            <span class="label">统计时间：</span>
            <span class="value">{{ datailData.staticalTime }}</span>
          </div>
        </div>
        <div class="info-line" v-if="datailData.PM10Avg || datailData.PM10ToadyAvg || datailData.VDMAvg">
          <div class="info-item" v-if="datailData.PM10Avg">
            <span class="label">PM10均值：</span>
            <span class="value">{{ datailData.PM10Avg }}μg/m³</span>
          </div>
          <div class="info-item" v-if="datailData.PM10ToadyAvg">
            <span class="label">全厂PM10均值：</span>
            <span class="value">{{ datailData.PM10ToadyAvg }}μg/m³</span>
          </div>
          <div class="info-item">
            <span class="label" v-if="datailData.VDMAvg">VDM均值：</span>
            <span class="value" v-if="datailData.VDMAvg">{{ datailData.VDMAvg }}μg/m³</span>
          </div>
        </div>
        <div class="info-line pollute-reason">
          <div class="info-item">
            <span class="label new-label-style">污染可能原因：</span>
            <span class="value new-value-style">{{ datailData.polluteReason }}</span>
          </div>
        </div>
      </div>
      <div class="dispatch-wrap">
        <div
          class="dispatch"
          :class="[datailData.handleState == 2 || datailData.handleState == 3 || datailData.handleState == '-' ? '' : 'dispatch-state']"
          @click.stop="dispatch(datailData.handleState == 2 || datailData.handleState == 3 || datailData.handleState == '-' ? true : false)"
        >
          发起调度
        </div>
        <div
          class="dispatch view-info"
          v-if="datailData.handleState != 2 && datailData.handleState != 3 && datailData.handleState != '-'"
          @click="viewTaskFun()"
        >
          {{ viewTask ? "收起" : "查看未完成任务" }}
        </div>
      </div>

      <div class="dispatch-info" v-if="viewTask">
        <div class="epr-info">
          <div class="info-title">闭环控制信息</div>
          <div class="info-line">
            <div class="info-item">
              <span class="label">编号：</span>
              <span class="value">{{
                workingInfo.workTicketNo ? workingInfo.workTicketNo : "--"
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span class="value">{{
                workingInfo.createTime ? workingInfo.createTime : "--"
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">责任人：</span>
              <span class="value">{{
                "--"
              }}</span>
            </div>
          </div>
          <div class="info-title">落实管理制度</div>
          <div class="info-line my-agency">
            <div
              class="processing-records"
              :class="[workingInfo.levelManageList.length == 1 ? 'one-record' : '']"
              v-if="workingInfo.levelManageList && workingInfo.levelManageList.length > 0"
            >
              <div
                class="processing-records-item"
                v-for="(item, index) in workingInfo.levelManageList"
                :key="index"
              >
                <span class="handler">{{ item.userName }}</span>
                <span class="circle"></span>
                <span class="step-name">{{
                  item.state == 0 ? "处理中" : item.state == 1 ? "已处理" : ""
                }}</span>
                <span class="partment">{{ item.officeName || "无" }}</span>
                <span class="handler-time">{{ item.date }}</span>
              </div>
            </div>
            <div v-else class="info-item">
              <span class="value">暂无数据</span>
            </div>
          </div>
          <div class="info-title">处理措施</div>
          <div class="info-line">
            <div class="info-item">
              <!-- <span class="label new-label-style">处理措施：</span> -->
              <span class="value">{{
                workingInfo.measure ? workingInfo.measure : "无"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dispatch-popup" v-if="dispatchPopupState">
        <div class="dispatch-top">
          <div class="dispatch-popup-title">发起调度</div>
          <!-- <div class="dispatch_close" @click="closeDispatchPopup"></div> -->
        </div>
        <div class="dispatch-content">
          {{ popupContent }}
        </div>
        <div class="but-group">
          <div class="but but-sure" @click.stop="dispatchPopup">确定</div>
          <div class="but but-close" @click="dispatch(false)">取消</div>
        </div>
      </div>
      <div class="tab-switch">
        <div class="tab-list">
          <div
            class="tab-item"
            :class="curTab == item.id ? 'tab-active' : ''"
            @click="switchTab(index)"
            v-for="(item, index) in tab"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="tab-content" v-if="curTab == 0">
        <div class="form">
          <el-form
            ref="myform"
            :inline="true"
            :model="formInline"
            class="demo-form-inline"
          >
            <el-form-item label="起止时间：">
<!--              <el-date-picker
                v-model="date"
                type="datetime"
                placeholder="选择时间"
                value-format="YYYY-MM-DD HH:mm:ss"
              >
              </el-date-picker>-->
              <DatePicker
                :init-width="'420px'"
                :start-time-str="date[0]"
                :current-date-list="date"
                :end-time-str="date[1]"
                @dateChange="date_change"
                dateType="timerange"
                topPx="50px"
              >
              </DatePicker>
            </el-form-item>
          </el-form>
        </div>
        <template v-if="pm10List.length > 0">
          <div>
            <line-chart
              v-for="(item, index) in pm10List"
              :key="index"
              :dataList="item"
              title="实时碳排放变化"
              class="mr-20 w-50"
            ></line-chart>
          </div>
        </template>
        <template v-if="vdms.length > 0 && !loading">
          <div
            :id="'vdmBlock_' + n"
            class="vdm"
            v-for="(item, n) in vdms"
            v-bind:key="item.deviceSN"
          >
            <div class="title">
              <span>联动图片</span>
            </div>
            <div class="vdmVideoBox vdm-img-box">
              <ul :class="getDiaporama(n)" v-show="diaporamaShow[n]">
                <li
                  class="vdm-img-list"
                  :class="'vdm-img-list' + (index + 1)"
                  :idx="'jDiaporama_' + item_.id"
                  v-bind:key="item_.id"
                  v-for="(item_, index) in imgListInfoArr[n]"
                  ::key="item_.id"
                >
                  <img
                    class="vdm-img"
                    :src="item_.imgUrl"
                    :title="getImgTitleDown(item_)"
                    alt=""
                  />
                </li>
              </ul>
              <div class="no-img" v-if="!diaporamaShow[n]">
                <img src="./img/nodata.png" alt="" />
                <span>暂无图片</span>
              </div>
            </div>
            <div class="vdm-charts">
              <div class="chart" :ref="'chart-' + n"></div>
              <div class="vdm-sn">
                <!-- <span class="spot"></span> -->
                <font class="equipType">VDM-</font>
                <font> {{ item.deviceName }}</font>
                <div class="gou-wrap">
                  <span class="gou"></span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="no-data" v-if="vdms.length == 0 && pm10List.length == 0 && !loading">
          <img src="./img/nodata.png" alt="" />
          <span>暂无数据</span>
        </div>
        <div
          v-if="loading"
          :style="{ width: '100%', height: '300px', position: 'relative' }"
        >
          <check-loading ref="checkLoading" v-if="loading"></check-loading>
        </div>
      </div>
      <div class="tab-content" v-if="curTab == 1">
        <div class="monitor-vedio">
          <div
            class="vedio-list"
            @click="playVedio(item)"
            v-for="(item, index) in vedioList"
            :key="index"
          >
            <!-- <div class="vedio-cover">
              <img src="./img/panelView_blackBg_3_3.png" alt="" />
            </div> -->
            <cvrVedio :videoInfo='item'></cvrVedio>
            <div class="vedio-name">{{ item.cameraName }}</div>

          </div>
        </div>
        <div class="no-data" v-if="vedioList.length == 0 && !loading">
          <img src="./img/nodata.png" alt="" />
          <span>暂无数据</span>
        </div>
      </div>
      <div class="tab-content" v-if="curTab == 2">
        <div class="process-record">
          <div class="record-list" v-for="(item, index) in recordList" :key="index">
            <div class="del-time">{{ item.time }}</div>
            <div class="content">{{ item.info }}</div>
          </div>
        </div>
        <div class="no-data" v-if="recordList.length == 0 && !loading">
          <img src="./img/nodata.png" alt="" />
          <span>暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import titleMod from "@/modules/DIYcomponents/components/componentsTools/titleMod/titleMod.vue";
import LineChart from "@/modules/mathRoadComponents/environmentalProtectionRoad/components/lineChart";
import cvrVedio from "@/modules/mathRoadComponents/environmentalProtectionRoad/components/cvrVedio";
import checkLoading from "@/modules/checkLoading";
import { unwarp,dateFormat } from "@/utils/tools.js";
import { DatePicker } from "@/modules/commonDatePicker";
import {
  reactive,
  ref,
  toRefs,
  onMounted,
  nextTick,
  createApp,
  onUnmounted,
  getCurrentInstance,
} from "vue";
function getOpt(pmData, that, n) {
  console.log("pmData", pmData);
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "rgba(0, 255, 255, 0.14)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(0, 255, 255, 0.14)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(0, 255, 255, 0.14)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(0, 255, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(0, 255, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 180,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params[0]) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${
              params[0].seriesName == "小时监测" ? "监测值" : "监测值"
            }: ${params[0].value} </span></br>`; //mg/m³
          } catch {
            console.log("出错了");
          }
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${params[i].seriesName}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${params[i].value[2].happenTime}</br>&nbsp;&nbsp;&nbsp;&nbsp;监测值：${params[i].value[2].vdmTdc}/span></br>`; //  mg/m³<
              } else if (params[i].value[2].isWarning == 2) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF7373;"></span><span>${"封闭失效监测"}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${
                  params[i].value[2].happenTime
                }</br>&nbsp;&nbsp;&nbsp;&nbsp;监测值：${
                  params[i].value[2].vdmTdc
                } </span></br>`; // mg/m³
              } else if (params[i].value[2].isWarning == 3) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ff0202;"></span><span>${"可见烟尘、封闭失效监测"}</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${
                  params[i].value[2].happenTime
                }</br>&nbsp;&nbsp;&nbsp;&nbsp;监测值：${
                  params[i].value[2].vdmTdc
                } </span></br>`; //mg/m³
              }
            } catch {
              console.log("出错了");
            }
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      right: "2.7%",
      top: "0%",
      data: [
        { name: "小时监测", icon: "circle" },
        { name: "可见烟尘监测 ", icon: "circle" },
        { name: "封闭失效监测", icon: "circle" },
        { name: "可见烟尘、封闭失效监测", icon: "circle" },
      ],
      formatter: function (name) {
        return name;
      },
      itemWidth: 14,
      itemHeight: 14,
      textStyle: {
        fontSize: 14,
        color: "#B8B8B8",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "34%",
      left: "3%",
      right: "3%",
      bottom: "4%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          lineStyle: {
            color: "rgba(62, 134, 219, 1)",
            width: 1,
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(62, 134, 219, 0.1)",
            width: 1,
          },
        },
        boundaryGap: true,
        axisLabel: {
          textStyle: {
            color: "#D7D7D7",
            fontSize: 12,
            margin: 15,
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: [
      {
        // name: '单位：mg/m³',
        nameTextStyle: {
          fontSize: 14,
          color: "#A6CAFF",
          padding: [0, 0, 0, 20],
        },
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(62, 134, 219, 0.2)",
            width: 1,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "rgba(62, 134, 219, 0.2)",
            width: 1,
          },
        },
        axisLabel: {
          margin: 10,
          textStyle: {
            color: "#D7D7D7",
            fontSize: 12,
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "小时监测",
        type: "line",
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          normal: {
            width: 2,
            color: "#439AFF",
          },
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.RadialGradient(
              0.5,
              0.5,
              0.5,
              [
                {
                  offset: 0,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 255, 255, 0.5)",
                },
              ],
              false
            ),
          },
        },
        data: y1Data,
      },
      {
        name: "可见烟尘监测",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 12,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [
                  {
                    offset: 0,
                    color: "rgba(247, 181, 0, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(247, 181, 0, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(247, 181, 0, 0.34)",
                  },
                  {
                    offset: 1,
                    color: "rgba(247, 181, 0, 0.34)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
      {
        name: "可见烟尘监测 ",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 12,
        itemStyle: {
          color: new echarts.graphic.RadialGradient(
            0.5,
            0.5,
            0.5,
            [
              {
                offset: 0,
                color: "rgba(247, 181, 0, 1)",
              },
              {
                offset: 0.6,
                color: "rgba(247, 181, 0, 1)",
              },
              {
                offset: 0.6,
                color: "rgba(247, 181, 0, 0.34)",
              },
              {
                offset: 1,
                color: "rgba(247, 181, 0, 0.34)",
              },
            ],
            false
          ),
        },
        data: [],
      },
    ],
  };
}
function formatDateTime(inputTime) {
    //			if(inputTime.dindexOf(':')!=-1){
    //				return inputTime;
    //			}else{
    inputTime = parseInt(inputTime);
    if (inputTime) {
      var date = new Date(inputTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    }
    //				return '--';
    //			}
  }
export default {
  name: "index",
  //import引入的组件需要注入到对象中才能使用
  components: {
    LineChart,
    checkLoading,
    cvrVedio,
    DatePicker
  },
  props: [
    "resultId",
    "riskLevel",
    "roadId",
    "roadName",
    "roadType",
    "roadTypeName",
    "VDMAvg",
    "PM10ToadyAvg",
    "PM10Avg",
  ],
  setup() {
    const { proxy, ctx } = getCurrentInstance();
    const data = reactive({
      realTimer: "",
      vdmRealData: [],
      formInline: {},
      // date: proxy.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      date: [
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date().getTime() - 24 * 60 * 60 * 1000),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ]
    });

    return {
      ...toRefs(data),
    };
  },

  data() {
    return {
      customerId: this.$store.state.customerId,
      vdms: [
        // {
        //     vdmImgList: [
        //         {
        //             collectionTime: "2021-07-28 23:38:33",
        //             // deviceNo: "BMEVDM0A210423008",
        //             id: 1475733,
        //             imgUrl: "http://visimg.bmetech.com/vdm/2021728/BMEVDM0A210423008/23_38_33_269.jpg",
        //             isAlarm: false,
        //             value: 10.735,
        //         },
        //         {
        //             collectionTime: "2021-07-28 22:38:11",
        //             // deviceNo: "BMEVDM0A210423008",
        //             id: 1471595,
        //             imgUrl: "http://visimg.bmetech.com/vdm/2021728/BMEVDM0A210423008/22_38_11_619.jpg",
        //             isAlarm: 1,
        //             value: 11.084
        //         },
        //         {
        //             collectionTime: "2021-07-28 21:37:55",
        //             // deviceNo: "BMEVDM0A210423008",
        //             id: 1467489,
        //             imgUrl: "http://visimg.bmetech.com/vdm/2021728/BMEVDM0A210423008/21_37_55_485.jpg",
        //             isAlarm: 2,
        //             value: 11.277,
        //         }
        //     ],
        //     signalDetailList: [
        //         {
        //             dateTime: "2021-07-28 23:38:33",
        //             value: 11.08
        //         },
        //         {
        //             dateTime: "22021-07-28 22:38:11",
        //             value: 11.277
        //         },
        //         {
        //             dateTime: "2021-07-28 21:37:55",
        //             value: 11.05
        //         },
        //         {
        //             dateTime: "2021-07-28 00:10:00",
        //             value: 10.95
        //         }
        //     ],
        //     deviceName: 'BMEVDM0A210423008'
        // }
      ],

      imgListInfoArr: [],
      vdmChart: {},
      options: [],
      imgListArr: [],
      imgUrl: [],
      cacheST: [],
      imgCache: [],
      cacheFinished: [],
      imgIdx: [],
      diaporamaShow: [],
      realTimer: "",
      vdmImgList: [],
      dealImgObj: [],

      tab: [
        {
          name: "趋势图",
          id: 0,
        },
        {
          name: "监控视频",
          id: 1,
        },
        // {
        //     name: '治理记录',
        //     id: 2
        // }
      ],
      curTab: 0,

      vedioList: [
      ],

      recordList: [
        {
          time: "2021-10-02 12:32:22",
          info: "经一路-炼钢1厂",
        },
        {
          time: "2021-10-02 12:32:22",
          info: "经一路-炼钢2厂",
        },
        {
          time: "2021-10-02 12:32:22",
          info: "经一路-炼钢3厂",
        },
        {
          time: "2021-10-02 12:32:22",
          info: "经一路-炼钢4厂",
        },
      ],

      datailData: {},
      pm10List: [],
      // roadId: 1,
      unit: 1,
      loading: false,
      roadCameraList: "",
      viewTask: false,
      dispatchPopupState: false,
      popupContent: "请确认是否调度最近车辆前往处理？",
      workTicketNo: "", // 202110061055231161667
      workingInfo: {},
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.getRegionHistory();
    });

    this.getRoadDetail();

    this.getRoadCameraList();
    // this.getTicketLevelManageRecords();
  },

  watch: {
    curTab: {
      //监听的对象
      deep: true, //深度监听设置为 true
      // immediate: true,
      handler: function (newV, oldV) {
        if (newV == 0) {
          this.getRegionHistory();
        }
      },
    },
    date: {
      //监听的对象
      deep: true, //深度监听设置为 true
      // immediate: true,
      handler: function (newV, oldV) {
        console.log("2112", newV);
        if (newV != oldV) {
          this.getRegionHistory();
        }
      },
    },
  },

  computed: {
    getDiaporama() {
      return function (n) {
        return "diaporama diaporama_" + n;
      };
    },
    getImgTitleDown() {
      return function (item) {
        return item.isAlarm == 1
          ? "可见烟尘监测, 监测值：" + item.value // + ' mg/m³'
          : item.isAlarm == 2
          ? "封闭失效监测, 监测值：" + item.value //  + ' mg/m³'
          : item.isAlarm == 3
          ? "可见烟尘、封闭失效监测, 监测值：" + item.value // + ' mg/m³'
          : "监测值：" + item.value; // + ' mg/m³'
      };
    },
  },

  methods: {
    date_change(val) {
      this.date = val;
    },
    changeTime(e) {
      this.datailData = e;
    },
    // 打开和关闭调度弹窗
    dispatch(state) {
      this.dispatchPopupState = state;
    },
    // 发起调度
    async dispatchPopup() {
      let that = this;
      let createWorkTicket = CONFIG.requestName + this.$apiOpt.createWorkTicket;
      let res = await this.$apiUtils.get(createWorkTicket, {
        customerId: this.customerId,
        roadId: this.roadId,
      });
      if (res) {
        this.popupContent = res['成功'];
        setTimeout(function () {
          that.getRoadDetail();
          that.getRoadCameraList();
          that.dispatch(false);
        }, 2000);
      }
    },
    // 工单详情
    async getTicketLevelManageRecords() {
      let getTicketLevelManageRecords =
        CONFIG.requestName + this.$apiOpt.getTicketLevelManageRecords;
      let res = await this.$apiUtils.get(getTicketLevelManageRecords, {
        customerId: this.customerId,
        workTicketNo: this.workTicketNo,
        state: 1,
      });
      if (res) {
        this.workingInfo = res;
      //   this.workingInfo.levelManageList = [
      //   {
      //     date: "2021-09-28 18:00:00",
      //     imgUrl: "http://bme-picture.oss-cn-qingdao.aliyuncs.com/work/ticket/avatar/default.png",
      //     level: 1,
      //     officeName: "环保部门A",
      //     state: 0,
      //     userName: "闭环一",
      //   },{
      //     date: "2021-09-28 20:00:00",
      //     imgUrl: "http://bme-picture.oss-cn-qingdao.aliyuncs.com/work/ticket/avatar/default.png",
      //     level: 2,
      //     officeName: "环保部门A",
      //     state: 0,
      //     userName: "闭环二",
      //   },{
      //     date: "2021-09-28 20:00:00",
      //     imgUrl: "http://bme-picture.oss-cn-qingdao.aliyuncs.com/work/ticket/avatar/default.png",
      //     level: 2,
      //     officeName: "环保部门A",
      //     state: 0,
      //     userName: "闭环三",
      //   }
      // ]
      }
    },

    viewTaskFun() {
      this.viewTask = !this.viewTask;
      if (this.viewTask) {
        this.getTicketLevelManageRecords()
      }

    },

    async getRoadDetail() {
      let getRoadDetail = CONFIG.requestName + this.$apiOpt.getRoadDetail;
      let res = await this.$apiUtils.get(getRoadDetail, {
        customerId: this.customerId,
        roadId: this.roadId,
        reportId: this.resultId,
      });
      if (res) {
        this.datailData = res;
        this.workTicketNo = res.workTicketNo;
      }
    },

    async getRoadCameraList() {
      let getRoadCameraList = CONFIG.requestName + this.$apiOpt.getRoadCameraList;
      let res = await this.$apiUtils.get(getRoadCameraList, {
        customerId: this.customerId,
        roadId: this.roadId,
      });
      if (res) {
        this.vedioList = [];
        for (let item of res) {
          this.vedioList = this.vedioList.concat(item.list);
        }
      }
    },

    // 播放视屏
    playVedio(item) {
      let that = this;
      //debugger;
      this.$store.commit("changeVideoPlayerSwitch", "open");
      this.updateNvrInfo(item);
    },

    // 获取VDM历史数据
    async getRegionHistory() {
      this.vdms = [];
      let that = this;
      let vdms = [];
      this.pm10List = [];
      this.loading = true;
      // that.$nextTick(function () {
      //     // setTimeout(() => {
      //     that.vdms.forEach((item, n) => {
      //         console.log("122", item)
      //         that.historicalOperation(item, n)
      //     })
      //     // })
      // })


      let getRoadDetailHistory = CONFIG.requestName + this.$apiOpt.getRoadDetailHistory;
      let res = await this.$apiUtils.get(getRoadDetailHistory, {
        customerId: this.customerId,
        roadId: this.roadId,
        reportId: this.resultId ? this.resultId : "",
        // startTime: this.$moment(this.date).format("YYYY-MM-DD") + " 00:00:00",
        // endTime: this.$moment(this.date).format("YYYY-MM-DD ") + " 23:59:59",
        startTime: this.date[0],
        endTime: this.date[1],
        unit: this.unit,
      });

      if (res) {
        this.loading = false;
        res.vdmResultList.forEach((vdmObj) => {
          vdms.push(vdmObj);
        });

        res.stationResultList.forEach((item) => {
          this.pm10List.push(item);
        });

        that.vdms = vdms;
        that.$nextTick(function () {
          // setTimeout(() => {
          that.vdms.forEach((item, n) => {
            that.historicalOperation(item, n);
          });
          // })
        });
      } else {
        this.loading = false;
      }
    },

    historicalOperation(vdmList, n) {
      let that = this;
      if (this.vdmChart[n]) {
        this.vdmChart[n] = null;
      }
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      let imgList = [];
      let tmpImgList = vdmList.vdmImgList.sort(function (a, b) {
        return (
          new Date(a.collectionTime).getTime() - new Date(b.collectionTime).getTime()
        );
      });
      // let tmpImgList = vdmList.vdmImgList

      tmpImgList.forEach((_) => {
        imgList.push(_.imgUrl);
      });

      that.imgListInfoArr[n] = tmpImgList;
      that.imgListArr[n] = imgList;
      that.imgUrl[n] = imgList[0];

      let signalDetailList = vdmList.signalDetailList.sort(function (a, b) {
        return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
      });

      // let signalDetailList = vdmList.signalDetailList

      signalDetailList.forEach((_) => {
        pmData.xData.push(_.dateTime);
        pmData.y1Data.push(_.value);
      });

      tmpImgList.forEach((m, n) => {
        m.tdc = m.value;
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (new Date(collectionTime).getTime() > new Date(pmDataList[i]).getTime()) {
              if (
                new Date(collectionTime).getTime() < new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.tdc);
              }
            }
          }
        }
      });

      tmpImgList.forEach((item, i) => {
        for (var x = 0; x < pmData.xData.length; x++) {
          if (item.collectionTime == pmData.xData[x]) {
            item.index = x;
            break;
          }
        }
      });
      tmpImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.value || 0,
          {
            isWarning: v.isAlarm,
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
          },
        ];
        pmData.y2Data.push(arr);
      });

      this.$nextTick(() => {
        if (that.vdmChart[n]) {
          that.vdmChart[n] = null;
        }

        that.vdmChart[n] = echarts.init(this.$refs["chart-" + n]);
        that.options[n] = getOpt(pmData, that, n);
        unwarp(that.vdmChart[n]).setOption(that.options[n]);
        that.bindVdmOver(that.vdmChart[n], n, that);

        //图片预加载
        that.cacheST[n] = new Date().getTime();
        that.imgCache[n] = [];
        that.cacheFinished[n] = false;
        that.imgListInfoArr[n].forEach((item) => {
          that.bindHandler(item, n, tmpImgList);
        });

        // setTimeout(function () {
        //     console.log('vdmChart', n)
        //     window.onresize = () => {
        //         that.vdmChart[0].resize()
        //         that.vdmChart[1].resize()
        //     }
        // }, 200)
      });
    },

    bindVdmOver(chart, n, that) {
      chart.on("mouseover", (a) => {
        if (a.value && a.value[2]) {
          that.imgUrl[n] = a.value[2].imgUrl;
          unwarp(chart).setOption({
            series: [
              {
                name: "可见烟尘监测",
                symbolSize: function (value) {
                  if (value[2].imgUrl == that.imgUrl[n]) {
                    if (
                      $("#vdmBlock_" + n).find(
                        "a[idx='jDiaporama_" + a.value[2].idx + "']"
                      ).length > 0
                    ) {
                      $("#vdmBlock_" + n)
                        .find("a[idx='jDiaporama_" + a.value[2].idx + "']")
                        .click();
                    }
                    if (
                      $("#vdmBlock_" + n).find(
                        "li[idx='jDiaporama_" + a.value[2].idx + "']"
                      ).length > 0
                    ) {
                      $("#vdmBlock_" + n)
                        .find("li[idx='jDiaporama_" + a.value[2].idx + "']")
                        .mouseenter();
                    }

                    return "16";
                  } else {
                    return "12";
                  }
                },
              },
            ],
          });
        }
      });
    },

    bindHandler(item, n, tmpImgList) {
      let that = this;
      let imgUrl = item.imgUrl;
      let img = new Image();
      img.addEventListener("load", (e) => {
        item.w = e.target.naturalWidth;
        item.h = e.target.naturalHeight;
        that.loadHandler(e, item, n, tmpImgList);
      });
      img.src = imgUrl;
    },

    loadHandler(e, item, n, imgList) {
      let curTime = new Date().getTime();
      this.imgCache[n].push(item.index);
      if (
        this.imgCache[n].length === imgList.length &&
        this.imgCache[n].length > 0 &&
        !this.cacheFinished[n]
      ) {
        this.cacheFinished[n] = true;
        this.picPreCache(imgList, n);
      } else if (curTime - this.cacheST[n] > 5 * 1000 && !this.cacheFinished[n]) {
        this.cacheFinished[n] = true;
        this.picPreCache(imgList, n);
      }
    },

    picPreCache(vdmList, n) {
      // console.log('vdmList', vdmList, n)
      this.vdmImgList[0] = vdmList;
      let that = this;
      let dealImgObj = {};
      vdmList.forEach((item) => {
        if (!dealImgObj[item.index]) {
          dealImgObj[item.index] = [];
        }
        dealImgObj[item.index].push({
          imgUrl: item.imgUrl,
          id: item.id,
        });
      });
      this.dealImgObj[n] = dealImgObj;

      let jqNode = $(".diaporama_" + n);
      jqNode.jDiaporama(
        {
          animationSpeed: "slow",
          delay: 2,
          auto: false,
        },
        function () {
          that.diaporamaShow[n] = true;
        },
        jqNode
      );
      if (!this.imgIdx[n]) {
        this.imgIdx[n] = {};
        this.imgIdx[n]["idx"] = 0;
      }

      // tools.loopShowTooltip(
      //     this.vdmChart[n],
      //     this.options[n],
      //     { interval: 100, },
      //     vdmList,
      //     dealImgObj,
      //     this.imgIdx[n]
      // );
    },

    toolLoop(n) {
      tools.clearLoop();
      tools.loopShowTooltip(
        this.vdmChart[n],
        this.options[n],
        "",
        this.vdmImgList[n],
        this.dealImgObj[n],
        this.imgIdx[n]
      );
    },

    switchTab(index) {
      this.curTab = index;
    },

    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped>
.epr_wrap-style {
  display: flex;
  flex-direction: column;
  .module-title {
    font-size: 26px;
    color: #f5a623;
    border-bottom: solid 2px #f5a623;
    padding: 0 90px;
    line-height: 48px;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    font-weight: 500;
  }
  .star {
    @include bg-box(18px, 18px, "star.png");
    margin-right: 10px;
  }
  .dispatch-wrap {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .dispatch {
      // width: 120px;
      padding: 0 30px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      border-radius: 3px;
      color: #99f5ff;
      margin-right: 20px;
      background: linear-gradient(
        180deg,
        rgba(108, 115, 255, 0.34) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      );
      border: 1px solid #8badff;
      cursor: pointer;
    }
    .dispatch-state {
      background: linear-gradient(
        180deg,
        rgba(202, 202, 202, 0.34) 0%,
        rgba(202, 202, 202, 0.2) 48%,
        rgba(179, 180, 182, 0.1) 100%
      );
      border: 1px solid #acacac;
      color: #fff;
      cursor: not-allowed;
    }
  }
}

.dispatch-popup {
  width: 600px;
  height: 280px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  color: #fff;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  .dispatch-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    width: 100%;
    .dispatch-popup-title {
      font-size: 24px;
      font-weight: 400;
      line-height: 40px;
      color: #f5a623;
      border-bottom: solid 2px #f5a623;
      padding: 0 40px;
    }
    .dispatch_close {
      position: absolute;
      top: 5px;
      right: 5px;
      background-image: url(/static/img/popupImg/closeBtn.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      box-shadow: 0px 2px 3px 0px rgb(0 0 0 / 22%);
      border-radius: 2px;
      width: 90px;
      height: 45px;
      line-height: 40px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .dispatch-content {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .but-group {
    display: flex;
    align-items: center;
    width: 100%;
    border-top: solid 1px #777777;
    padding: 14px 0;
    justify-content: center;
    .but {
      color: #fff;
      border: solid 1px #c8dde1;
      padding: 0px 28px;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
      border-radius: 4px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
    .but-sure {
      background: linear-gradient(
        180deg,
        rgba(108, 115, 255, 0.34) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      );
      border: 1px solid #8badff;
    }
  }
}

.tab-switch {
  margin-top: 30px;
  .tab-list {
    display: flex;
    align-items: center;
    // border: solid 1px #fff;
    height: 56px;
    .tab-item {
      text-align: center;
      line-height: 56px;
      font-size: 22px;
      cursor: pointer;
      flex: 1;
      border: 1px solid rgba($color: #8badff, $alpha: 0.35);
      color: #9e9e9e;
    }
    .tab-active {
      color: #99f5ff;
      background: linear-gradient(
        180deg,
        rgba(108, 115, 255, 0.34) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      );
      border: 1px solid #8badff;
    }
  }
}

.epr-content-wrap {
  position: relative;
  overflow-y: auto;
  margin-top: 60px;
  padding: 40px 80px;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 4px;
    background: linear-gradient(180deg, #449eff 0%, #1e5cbb 100%);
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 8px;
    // background: #fff;
    width: 8px;
  }
  .title {
    margin-bottom: 10px;
    margin-top: 20px;
    span {
      font-size: 16px;
      font-weight: 400;
      color: #7ff2ff;
      line-height: 16px;
    }
  }

  .tab-content {
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.14) 0%,
      rgba(107, 151, 255, 0.14) 48%,
      rgba(58, 116, 255, 0.07) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid rgba($color: #8badff, $alpha: 0.1);
    padding: 40px;
  }

  .form {
    height: 69px;
    // background: rgba($color: #000, $alpha: 0.24);
    // box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    margin-bottom: 35px;
  }

  .dispatch-info {
    margin-top: 30px;
    border: solid 1px #b8b8b8;
    padding: 30px;
    border-radius: 2px;
    .epr-info {
      .info-line {
        padding: 0 40px;
        margin-bottom: 20px;
        color: #b8b8b8;
      }
    }
  }

  .epr-info {
    .info-title {
      font-size: 24px;
      font-weight: 600px;
      color: #b8b8b8;
      margin-bottom: 30px;
    }
    .info-line {
      display: flex;
      align-items: center;
      .info-item {
        width: 33%;
        display: flex;
        align-items: center;
        height: 29px;
        margin-bottom: 18px;
        margin-right: 50px;
        font-size: 18px;
        box-sizing: border-box;
        &:last-child {
          margin-right: 0;
        }
        .label {
          display: inline-block;
          width: 150px;
          text-align: right;
          line-height: 29px;
          color: #b8b8b8;
        }
        .value {
          flex: 1;
          line-height: 29px;
          display: inline-block;
          white-space: nowrap;
          color: #c8dde1;
          overflow: hidden;
          text-overflow: ellipsis;
          // border-bottom: 1px dashed #4b4b4b;
        }
        .new-label-style {
          color: #f5a623;
        }
        .new-value-style {
          color: #ff7373;
        }
      }
    }
    .pollute-reason {
      .info-item {
        width: 100%;
      }
    }
  }
}

.vdm-img-box {
  display: flex;
  justify-content: center;
  margin-bottom: 37px;
  height: 270px;
  background: rgba($color: #000, $alpha: 0.11);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    min-width: 500px;
    .vdm-img-list {
      min-width: 500px;
    }

    .vdm-img {
      min-width: 500px;
      height: 270px;
    }
  }
}

.vdm-charts {
  background: rgba($color: #000, $alpha: 0.11);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
  padding: 50px 0 10px 0;
  position: relative;
  .vdm-sn {
    width: 385px;
    height: 24px;
    // background: linear-gradient(
    //     145deg,
    //     rgba(9, 19, 27, 0) 0%,
    //     #041226 100%
    // );
    // box-shadow: -5px -5px 4px 0px rgba(46, 130, 255, 0.09);
    // border: 1px solid rgba($color: #2eb5ff, $alpha: 0.6);
    display: flex;
    align-items: center;
    position: absolute;
    margin-left: 0px;
    left: 0;
    top: 50px;
    .spot {
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #82ff94;
      border-radius: 10px;
      position: relative;
      margin-right: 40px;
      margin-left: 20px;
      &::before {
        content: "";
        height: 1px;
        width: 40px;
        background: #82ff94;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    font {
      font-size: 16px;
      font-weight: 300;
      color: #c8dde1;
    }
  }
  .chart {
    height: 300px;
    widows: 100%;
  }
}

.no-data,
.no-img {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: rgba($color: #000000, $alpha: 0.2);
  padding: 50px 0 10px 0;
  img {
    width: 200px;
  }
  span {
    color: #505f83;
    font-size: 16px;
    margin-top: 8px;
  }
}
.no-img {
  background: none;
}

.monitor-vedio {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .vedio-list {
    width: calc(100%);
    // margin-right: 20px;
    margin-bottom: 30px;
    // height: 400px;
    display: flex;
    flex-direction: column;
    &:nth-child(2n) {
      margin-right: 0;
    }
    .vedio-cover {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      overflow: hidden;
      img {
        width: 100%;
        object-fit: contain;
        border: 0;
        margin: 0;
      }
    }
    .vedio-name {
      font-size: 20px;
      font-weight: 400;
      color: #b8b8b8;
      line-height: 56px;
      height: 44px;
      text-align: center;
    }
  }
}
.process-record {
  .record-list {
    margin-bottom: 25px;
    .del-time {
      font-size: 18px;
      font-weight: 400;
      color: #f4c48f;
      line-height: 28px;
    }
    .content {
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      line-height: 28px;
    }
  }
}
.my-agency {
  width: 100%;
  .processing-records {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    position: relative;
    flex: 1;
    &::before {
      content: "";
      width: calc(100% - 180px);
      height: 6px;
      background: #076d4e;
      position: absolute;
      left: 50%;
      top: 48px;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
    }
    .processing-records-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .handler {
        min-width: 80px;
        max-width: 110px;
        padding: 0 5px;
        height: 26px;
        text-align: center;
        background: #bbeedf;
        box-shadow: 0px 10px 5px -7px rgba(33, 179, 134, 0.5);
        border: 1px solid #0b5a68;
        border-radius: 2px;
        line-height: 25px;
        font-size: 14px;
        font-weight: 400;
        color: #0b5a68;
        position: relative;
        margin-bottom: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        &::before {
          content: "";
          width: 10px;
          height: 10px;
          background: #bbeedf;
          border-left: 1px solid #0b5a68;
          border-bottom: 1px solid #0b5a68;
          // transform: rotate3d(90deg);
          position: absolute;
          left: 50%;
          transform: rotate(-45deg) translateX(-50%);
          bottom: -2px;
        }
      }
      .circle {
        width: 22px;
        height: 22px;
        background: #ffffff;
        box-shadow: 0px 2px 4px 0px rgba(33, 176, 179, 0.43);
        border: 1px solid #076d4e;
        position: relative;
        border-radius: 50%;
        &::before {
          content: "";
          width: 8px;
          height: 8px;
          background: #0b5a68;
          border-radius: 4px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .step-name {
        font-size: 12px;
        font-weight: 400;
        color: #0b5a68;
        line-height: 12px;
        margin-top: 8px;
        font-weight: 500;
      }
      .partment {
        font-size: 14px;
        font-weight: 400;
        line-height: 12px;
        margin-top: 8px;
      }
      .handler-time {
        font-size: 12px;
        font-weight: 400;
        color: #606060;
        line-height: 12px;
        margin-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 120px;
      }
    }
  }
  .one-record {
    &::before {
      width: 0px;
    }
  }
  .input-style-text {
    color: #b8b8b8;
    font-size: 16px;
  }
}
</style>

<style lang="scss">
.epr_style {
  left: 50% !important;
}
.epr_wrap-style {

  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item .el-form-item__label {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #99f5ff;
  }
  .el-form-item {
    margin: 0px;
  }
  .el-input__inner {
    width: 300px;
    height: 36px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 1px 0px #5bb4ff;
    border-radius: 6px;
    border: none;
    color: #99f5ff !important;
    font-size: 16px;
    &::placeholder {
      color: #99f5ff !important;
      font-size: 16px;
    }
  }
  .cleanTransport_container_green .el-form-item__content .el-date-editor,
  .el-form-item__content .el-date-editor input {
    color: #99f5ff !important;
    font-size: 16px;
    &::placeholder {
      color: #99f5ff !important;
      font-size: 16px;
    }
  }
  .el-form-item__content .el-date-editor,
  .el-form-item__content .el-date-editor input {
    height: 36px;
    width: 300px;
  }
  .el-icon-date:before {
    color: #99f5ff;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
}
</style>
